import { useEffect, useMemo, useState } from "react";
import type { TFunction } from "i18next";
import getMoodImages from "utils/moods/getMoodImages";

type UseCheckInEnMoodSelectionParams = {
  theme: unknown;
  collection: unknown;
  t: TFunction;
  feelingName: string | null;
  mergedImageIndex: number | null | undefined;
};

export function useCheckInEnMoodSelection({
  theme,
  collection,
  t,
  feelingName,
  mergedImageIndex,
}: UseCheckInEnMoodSelectionParams) {
  const moodImages = useMemo(
    () => getMoodImages(theme, collection, t),
    [theme, collection, t]
  );

  const feelingNames = useMemo(
    () => moodImages.map((m: { enLabel: string }) => m.enLabel),
    [moodImages]
  );

  const [selectingMood, setSelectingMood] = useState<number | null | undefined>(
    mergedImageIndex
  );

  const [relevantMoods, setRelevantMoods] = useState<Record<string, unknown>>(
    {}
  );

  useEffect(() => {
    if (selectingMood == null && feelingName && feelingNames.length > 0) {
      const computedIndex = feelingNames.findIndex(
        (label) => label === feelingName
      );
      if (computedIndex !== -1) {
        setSelectingMood(computedIndex);
      }
    }
  }, [feelingName, feelingNames, selectingMood]);

  return {
    feelingNames,
    selectingMood,
    setSelectingMood,
    relevantMoods,
    setRelevantMoods,
  };
}
